module.exports = __webpack_public_path__ + "static/media/LandingPage_BackgroundPic.5819b406.jpg";